module.exports = __webpack_public_path__ + "static/media/Blockchain Beyond the Hype.83ae903a.png";